import { render, staticRenderFns } from "./scldbg.vue?vue&type=template&id=45e3c28b&scoped=true&"
import script from "./scldbg.vue?vue&type=script&lang=js&"
export * from "./scldbg.vue?vue&type=script&lang=js&"
import style0 from "./scldbg.vue?vue&type=style&index=0&id=45e3c28b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e3c28b",
  null
  
)

export default component.exports